
export enum ShipmentVolumeMethodCd {
	ACTL_DIM = 'ActlDim',
	DFLT_SHPR_PRFL = 'DfltShprPrfl',
	SHPR_PRFL_FOR_DEST_ZIP = 'ShprPrflForDestZip',
	SVC_CENTER_PRFL = 'SvcCenterPrfl',
	SYSTEM_PRFL = 'SystemPrfl'}

